import { computed, onMounted, toRefs } from 'vue';
import { defineComponent } from 'vue';
import { usePaymentForm } from './usePaymentForm';

export default defineComponent({
  el: '#payment-form-due',
  setup() {
    const {
      state,
      handleTokenizingResponse,
      onCountryChange,
      payingWithCredit,
      payingWithACH,
      isCanadianVersion,
      setNewPaymentMethod,
      selectCreditCard,
      selectACHAccount,
      availableCredits,
      creditsCoverTotalCost,
      totalPurchased,
      totalPaid,
      calculateCreditCardFee,
      calculateTotalWithoutCreditCardFee,
      calculateTotalWithCreditCardFee,
      baseValidationsFailed,
      deleteCredit,
      unableToAddCredit,
      addCredit,
      isNewCreditCard,
      onCreditCardSelectChange,
      onAchSelectChange,
      isNewAchAccount,
    } = usePaymentForm();

    const disableForm = computed(() => {
      return baseValidationsFailed();
    });

    return {
      ...toRefs(state),
      handleTokenizingResponse,
      disableForm,
      payingWithCredit,
      payingWithACH,
      isCanadianVersion,
      onCountryChange,
      unableToAddCredit,
      addCredit,
      deleteCredit,
      availableCredits,
      creditsCoverTotalCost,
      setNewPaymentMethod,
      selectCreditCard,
      calculateTotalWithCreditCardFee,
      calculateTotalWithoutCreditCardFee,
      totalPurchased,
      totalPaid,
      calculateCreditCardFee,
      selectACHAccount,
      isNewCreditCard,
      onCreditCardSelectChange,
      onAchSelectChange,
      isNewAchAccount,
    };
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleTokenizingResponse);
  },
});
